var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckSolidGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_2733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 11C22 17.0802 17.0794 22 11 22C4.91975 22 0 17.0794 0 11C0 4.91975 4.92059 0 11 0C17.0802 0 22 4.92059 22 11Z",
    fill: "#35d269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4768 9.16722C15.8125 8.83169 15.8125 8.28753 15.4768 7.95184C15.1413 7.61631 14.5971 7.61631 14.2614 7.95184L9.10384 13.1096L6.96698 10.9727C6.63145 10.6371 6.0873 10.6371 5.75177 10.9727C5.41608 11.3083 5.41608 11.8524 5.75177 12.188L8.49623 14.9326C8.83192 15.2681 9.37592 15.2681 9.71161 14.9326L15.4768 9.16722Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_2733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSolidGreen);
export default __webpack_public_path__ + "static/media/check-solid-green.1ea3e3c32265f06ba7fb0fc95e2c1d4d.svg";
export { ForwardRef as ReactComponent };